'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NewTab = require('./NewTab');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NewTab).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/NewTab/index.js
// module id = 122
// module chunks = 0 1 2 3 4 5 6 7 8 9